module.exports = __webpack_public_path__ + "img/1925_uk.6d40f8b4.svg";